export default __webpack_public_path__ + "static/element2-09f0d3c92e5db70d4608b5a147b749f6.png";